/**
 * Created by r4zi4l on 24.08.2021
 */

const OrderDetails = cc.Node.extend({
    ctor: function (orders) {
        this._super();

        this.orders = orders;
        this.maker = orders.getCurrentMaker();

        this.setContentSize2(cleverapps.styles.OrderDetails);

        this.createContent();

        this.orders.on("makerSelected", this.updateMaker.bind(this), this);
        this.orders.on("orderStateChanged", this.updateOrder.bind(this), this);
        this.orders.on("orderStateChanged", this.updateIngredients.bind(this), this);
    },

    createContent: function () {
        const styles = cleverapps.styles.OrderDetails;
        const leftBasket = this.leftBasket = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.ow_bucket, cleverapps.UI.Scale9Rect.TwoPixelX);
        leftBasket.setContentSize2(styles.bucket.width, leftBasket.height);
        leftBasket.setAlignment(styles.bucket.left);
        this.addChild(leftBasket);

        const rightBasket = this.rightBasket = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.ow_bucket, cleverapps.UI.Scale9Rect.TwoPixelX);
        rightBasket.setContentSize2(styles.bucket.width, rightBasket.height);
        rightBasket.setAlignment(styles.bucket.right);
        if (cleverapps.config.name === "hustlemerge") {
            rightBasket.setScaleX(-1);
        }
        this.addChild(rightBasket);

        const arrow = this.arrow = new cleverapps.Spine(bundles.orderswindow.jsons.ow_exchange_arrows);
        arrow.setAnimation(0, "idle", false);
        arrow.setAlignment(styles.arrows);
        this.addChild(arrow);

        if (this.maker) {
            this.ingredients = this.createIngredients();
            this.addChild(this.ingredients);

            this.rewards = this.createRewards();
            this.addChild(this.rewards);

            let turn = 0;
            arrow.setCompleteListener(() => {
                const animation = turn % 2 ? "idle" : "exchange";
                turn += 1;

                if (!this.maker || this.maker.getState() !== Customer.STATE_COOKING) {
                    arrow.setAnimation(0, animation, false);
                }
            });
        }

        this.button = this.createButton();
    },

    createButton: function () {
        const styles = cleverapps.styles.OrderDetails.button;

        const buttonOptions = {
            width: styles.width,
            height: styles.height,
            onClicked: this.onButtonClick.bind(this)
        };

        switch (this.maker && this.maker.getState()) {
            case Customer.STATE_RECIPE:
                if (this.maker.canCook()) {
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                } else if (typeof HungryGamesCustomer !== "undefined" && this.maker.unit.findComponent(HungryGamesCustomer)) {
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                    buttonOptions.disabled = true;
                } else {
                    buttonOptions.text = this.orders.getBuyIngredientsText(this.maker);
                }
                break;

            case Customer.STATE_READY:
                buttonOptions.text = Messages.get("Claim");
                break;

            case Customer.STATE_COOKING:
                buttonOptions.canCoins = true;
                buttonOptions.price = Unit.CalcSpeedUPPrice(this.maker.getCookingTimeLeft());
                buttonOptions.freeIcon = TextWithIcon.ICONS_BY_NAME.speedup;
                buttonOptions.eventName = cleverapps.EVENTS.SPENT.ORDER;
                buttonOptions.speedUp = true;
                buttonOptions.type = cleverapps.styles.UI.Button.Images.button_blue;

                if (ConfirmSpeedUpWindow.isAvailable(buttonOptions.price)) {
                    buttonOptions.confirmWindowOptions = {
                        timeLeft: this.maker.getCookingTimeLeft(),
                        totalDuration: this.maker.recipe.cookingDuration
                    };
                }
                break;

            default:
                buttonOptions.disabled = true;
                buttonOptions.text = Messages.get("OrdersWindow.button.make");
        }

        let button;
        if (this.maker && this.maker.getState() === Customer.STATE_COOKING) {
            button = new UseGoldButton(buttonOptions);
        } else {
            button = new cleverapps.UI.Button(buttonOptions);
        }

        button.setAlignment(styles);
        this.addChild(button); 

        if (this.maker && (this.maker.getState() === Customer.STATE_READY || cleverapps.tutorial.checkConditions({ unit: this.maker.unit }))) {
            button.runAction(new cc.Sequence(
                new cc.DelayTime(Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() ? 0.3 : 2.5),
                new cc.CallFunc(() => {
                    FingerView.hintTap(button, {
                        delay: 2.5,
                        repeatDelay: 2.5
                    });
                })
            ));
        }

        return button;
    },

    createIngredients: function () {
        const styles = cleverapps.styles.OrderDetails.ingredients;

        const icons = this.maker.recipe.ingredients.map(function (ingredient) {
            return new IngredientOrderIcon(ingredient, this.maker);
        }, this);

        const ingredients = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        ingredients.setAlignment(styles);
        return ingredients;
    },

    createRewards: function () {
        const styles = cleverapps.styles.OrderDetails.rewards;

        const orderUnits = this.maker.recipe.order.reduce((acc, item) => {
            for (let i = 0; i < item.amount; i++) {
                acc.push({ unit: item.unit });
            }
            return acc;
        }, []);

        const icons = orderUnits.map((item) => {
            const image = CustomerRecipe.getIngredientIcon(item);
            image.setScale(styles.image.scale);
            image.setAnchorPoint(0.5, 0);
            return image;
        });

        const provider = this.maker.unit.components.find((component) => component.getOrderRewards);
        if (provider && provider.getOrderRewards()) {
            new RewardsList(provider.getOrderRewards(), { event: cleverapps.EVENTS.EARN.OTHER }).listRewards().forEach((reward) => {
                const icon = reward.getIcon();
                icon.setScale(styles.image.scale);
                icon.setAnchorPoint(0.5, 0);
                icons.push(icon);
            });
        }

        const rewards = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        rewards.setAlignment(styles);
        return rewards;
    },

    changeButton: function () {
        this.button.stopAllActions();
        this.button.disabled = true;
        this.button.runAction(new cc.Sequence(
            new cc.ScaleTo(0.3, 0.85),
            new cc.RemoveSelf()
        ));
        this.button = this.createButton(this.maker);
        this.button.setVisible(false);
        this.button.setScale(0.85);
        this.button.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.Show(),
            new cc.ScaleTo(0.3, 1)
        ));
    },

    changeIngredients: function () {
        if (this.ingredients) {
            this.removeAnimated(this.ingredients);
            this.ingredients = undefined;
        }

        if (this.maker) {
            this.ingredients = this.createIngredients();
            this.addChild(this.ingredients);
            this.showAnimated(this.ingredients);
        }
    },

    changeRewards: function () {
        if (this.rewards) {
            this.removeAnimated(this.rewards);
            this.rewards = undefined;
        }

        if (this.maker) {
            this.rewards = this.createRewards();
            this.addChild(this.rewards);
            this.showAnimated(this.rewards);
        }
    },

    updateMaker: function (maker) {
        if (maker === this.maker) {
            return;
        }
        this.maker = maker;

        this.changeButton();
        this.changeIngredients();
        this.changeRewards();
    },

    updateOrder: function (maker) {
        if (this.maker === maker) {
            this.changeButton();
        }
    },

    updateIngredients: function () {
        const canCook = this.maker && this.maker.canCook();
        if (this.canCook !== canCook) {
            this.canCook = canCook;
            this.changeButton();
        }

        if (this.maker && this.maker.getState() === Customer.STATE_RECIPE) {
            this.ingredients.children.forEach((icons) => {
                icons.updateAmount(Map2d.currentMap.stock.getStockAmount(icons.ingredient));
            });
        }
    },

    onButtonClick: function () {
        this.orders.processOrder(this.maker);
    },

    removeAnimated: function (node) {
        node.children.forEach((child) => {
            if (child.beforeRemoveAnimated) {
                child.beforeRemoveAnimated();
            }
        });

        node.setCascadeOpacityEnabledRecursively(true);
        node.runAction(new cc.Spawn(
            new cc.MoveBy(0.3, 0, cleverapps.styles.OrderDetails.delta.y).easing(cc.easeOut(2)),
            new cc.FadeOut(0.4),
            new cc.Sequence(
                new cc.ScaleTo(0.3, 0.5).easing(cc.easeIn(2)),
                new cc.RemoveSelf()
            )
        ));
    },

    showAnimated: function (node) {
        node.setCascadeOpacityEnabledRecursively(true);
        node.setScale(0.8);
        node.setOpacity(0.3);

        node.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.Spawn(
                new cc.FadeIn(0.4),
                new cc.ScaleTo(0.3, 1)
            )
        ));
    }
});

cleverapps.styles.OrderDetails = {
    width: 1240,
    height: 200,

    delta: {
        y: 100
    },

    bucket: {
        left: {
            x: { align: "center", dx: -370 },
            y: { align: "center", dy: 10 }
        },
        right: {
            x: { align: "center", dx: 360 },
            y: { align: "center", dy: 10 }
        },
        width: 550
    },

    arrows: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: 55 }
    },

    button: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: -60 },
        width: 260,
        height: 86
    },

    ingredients: {
        margin: 0,
        x: { align: "center", dx: -390 },
        y: { align: "bottom", dy: 52 }
    },

    rewards: {
        x: { align: "center", dx: 350 },
        y: { align: "bottom", dy: 77 },
        margin: 20,

        image: {
            scale: 1.2
        }
    }
};
